const BulkPurchaseReducer = (state, action) => {
  switch (action.type) {
    // --------- Billing Contact Info Actions ------------ //
    // Handles the display of the additional billing contact info fields
    case 'setBillingContactInfoNeeded':
      return { ...state, billingContactInfoNeeded: action.value };

    // --------- Bulk Purchase Code/Package Actions ------------ //
    // Stores the BulkPurchaseCode object returned from db api call
    case 'setBulkPurchaseCode':
      return { ...state, bulkPurchaseCode: action.value };
    // Stores the available BulkPurchasePackages from API call to divesite
    case 'setPackages':
      return { ...state, packages: action.value };
    // Contains the active BulkPurchasePackage primary_key which subsequently modifies styling
    case 'setActivePackage':
      return { ...state, activePackage: action.value };
    // Sets a state variable that contains the active package as an object
    case 'setActivePackageObject':
      return { ...state, activePackageObject: action.value };
    // Handles the number of PressReleases selected, removing linting on this line
    // until we use numPressReleases state variable (next ticket)'
    case 'setNumPressReleases':
      return { ...state, numPressReleases: action.value };

    // -------------- Validation/Navigation actions --------------- //
    // Indicates whether checkout or confirmation page should be shown
    // based on successful/unsuccessful Stripe transaction
    case 'setPaidStatus':
      return { ...state, paid: action.value };
    // validation state piece that indicates whether the form is ready for submission
    case 'showSpinner':
      return { ...state, isSubmitting: true };
    case 'hideSpinner':
      return { ...state, isSubmitting: false };
    // Handles if the Next button has been clicked and removes button from
    // being rendered
    case 'showPaymentInformation':
      return { ...state, next: !state.next };
    // Indicates whether or not we should scroll to top of validation errors in form
    case 'setScrollToTopmostError':
      return { ...state, scrollToTopmostError: action.value };

    // ------------ Stripe actions -------------------- //
    // Client secret returned by stripe in the initial creation of the payment intent
    case 'setClientSecret':
      return { ...state, clientSecret: action.client_secret };
    // ID specific to this checkout session
    case 'setPaymentIntentId':
      return { ...state, paymentIntentId: action.id };
    default:
      throw new Error();
  }
};

export default BulkPurchaseReducer;
